module.exports = {"master":{"setings":"Settings"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/master.json
// module id = 552
// module chunks = 27